import { useMutation } from "react-query";
import { CreateTreatmentPayload } from "../../Interfaces/FeatureFlip";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";

interface CreateTreatmentPayloadP extends CreateTreatmentPayload {
  projectId: string;
  featureId: string;
}

const createTreatments = async (payload: CreateTreatmentPayloadP) => {
  try {
    const url = paths.createTreatments();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useCreateTreatments = () => {
  return useMutation(createTreatments);
};
